import { InversionChangedHistoryItem } from "./InversionChangedHistoryItem";
import { OverridesChangedHistoryItem } from "./OverridesChangedHistoryItem";
import { RulesChangedHistoryItem } from "./RulesChangedHistoryItem";
import { SegmentArchivedHistoryItem } from "./SegmentArchivedHistoryItem";
import { SegmentCampaignHistoryItem } from "./SegmentCampaignHistoryItem";
import { SegmentCreatedHistoryItem } from "./SegmentCreatedHistoryItem";
import { TypeChangedHistoryItem } from "./TypeChangedHistoryItem";
import { VacanciesAddedHistoryItem } from "./VacanciesAddedHistoryItem";
import { VacanciesRemovedHistoryItem } from "./VacanciesRemovedHistoryItem";

import {
  HistoryEntryDispatcher,
  type EntityHistoryEntry,
  type HistoryItemMap,
} from "@/components/ui/v2/history";

const SEGMENT_HISTORY_ITEMS: HistoryItemMap = {
  SegmentCreated: SegmentCreatedHistoryItem,
  RulesChanged: RulesChangedHistoryItem,
  TypeChanged: TypeChangedHistoryItem,
  InversionChanged: InversionChangedHistoryItem,
  VacanciesAdded: VacanciesAddedHistoryItem,
  VacanciesRemoved: VacanciesRemovedHistoryItem,
  OverridesChanged: OverridesChangedHistoryItem,
  SegmentAddedToCampaign: SegmentCampaignHistoryItem,
  SegmentRemovedFromCampaign: SegmentCampaignHistoryItem,
  SegmentArchived: SegmentArchivedHistoryItem,
};

export function HistoryEntryItem({ entry }: { entry: EntityHistoryEntry }) {
  return (
    <HistoryEntryDispatcher
      entry={entry}
      items={SEGMENT_HISTORY_ITEMS}
      i18nPrefix="admin.segments.history"
    />
  );
}
